<template>
    <div class="card">
        <div class="card-header" v-if="hasheaderslot">
            <slot name="header"></slot>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
        <div class="card-footer" v-if="hasfooterslot">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script setup>
import { useSlots, computed } from 'vue'

const slots = useSlots();

const hasheaderslot = computed(() => slots.header)
const hasfooterslot = computed(() => slots.footer)

</script>
